/**
 * 파일명: aboutAsset.js
 * 작성자: 김준형
 * 작성일자: 26.08.10
 * 설명: About Us - 배경 사진 경로
 */
import { useMediaQuery } from "react-responsive";

const ABOUT_BG = {
  hero: { pc: "title_bg.png", mo: "title_m.png" },
  growing: { pc: "growing_bg.png", mo: "growing_m.png" },
  tomorrow: { pc: "tomorrow.png", mo: "tomorrow_m.webp" },
  // 모바일 1, 2번 파일은 PC 와 번호가 반대로 붙어 있다. 그림 기준으로 연결한다.
  value_tech: { pc: "tomorrow_1_bg.png", mo: "tomorrow_2_m.png" },
  value_customer: { pc: "tomorrow_2_bg.png", mo: "tomorrow_1_m.png" },
  value_culture: { pc: "tomorrow_3_bg.png", mo: "tomorrow_3_m.png" },
  ceo_profile: { pc: "cei_profile.png", mo: "ceo_profile_m.png" },
  ceo_pattern: { pc: "profile_right.png", mo: "profile_rignt_m.png" },
  history_company: { pc: "company_bg.png", mo: "company_bg_m.png" },
  history_solution: { pc: "solution_bg.png", mo: "solution_bg_m.png" },
  contact: { pc: "Contact_us_bg.png", mo: "Contact_us_bg_m.png" },
};

function useAboutBg() {
  const isCompact = useMediaQuery({ query: "(max-width: 1024px)" });

  return (name) => {
    const asset = ABOUT_BG[name];
    if (!asset) return undefined;

    const file = (isCompact && asset.mo) || asset.pc;

    return {
      backgroundImage: `url('${process.env.REACT_APP_CLIENT_URL}img/about/${file}')`,
    };
  };
}

export default useAboutBg;
